<template>
  <div class="p-14 flex flex-col items-center justify-center">
    <PhoneVerifiedIcon v-if="contactType === 1" :color="color" class="mb-8" />
    <EmailVerifiedIcon v-else :color="color" class="mb-8" />
    <p class="text-body-5 font-medium text-default-1 mb-3">Congratulations!</p>
    <p class="text-body-6 text-default-1 text-center mb-6">
      Your {{ contactText }}
      <span class="font-medium"> {{ contact }} </span> has been verified.
    </p>
    <CoreButton buttonType="primary" label="Save changes" size="default" @click="saveChanges" />
  </div>
</template>
<script setup>
import CoreButton from '../../core/Button.vue';
import PhoneVerifiedIcon from '../../icons/phone/Verify.vue';
import EmailVerifiedIcon from '../../icons/email/Verify.vue';

const props = defineProps(['contactType', 'show', 'color', 'contactText', 'contact']);
const emit = defineEmits(['update:show', 'saveChanges']);

function saveChanges() {
    emit('saveChanges');
}
</script>